module.exports = __webpack_public_path__ + "static/media/arrow-down-up.f6b9eebf.svg";